module.exports = __webpack_public_path__ + "media/footer/Instagram-a778f79e.png";